import React from 'react'
import MaterialSymbol from '../material-symbol'

const Height = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="height" {...props} />
))

Height.displayName = 'Height'

export default Height
